import {MoreVert} from "@mui/icons-material";
import {IconButton, Menu} from "@mui/material";
import React from "react";
import {EnlilTable} from "../EnlilTable";
import {withAppContext} from "../withAppContext";
import withNavigate from "../../util/useNavigate";
import withBreakpoint from "../../util/withBreakpoint";
import EventBus from "../../util/EventBus";
import css_buttons from "../Common/css/CCButton.module.scss";

class EmployeeTable extends EnlilTable {

    componentDidMount() {
        super.componentDidMount();

        EventBus.components.addListener("employee-form-applet-cancel", this.onCancelHandler);
        EventBus.components.addListener("employee-form-applet-save", this.onCancelHandler);
    }

    componentWillUnmount() {
        super.componentWillUnmount();

        EventBus.components.removeListener("employee-form-applet-cancel", this.onCancelHandler);
        EventBus.components.removeListener("employee-form-applet-save", this.onCancelHandler);
    }

    getCellRenderer(name) {
        if (name === "Action Cell") {
            return this.renderActionCell;
        }
        return super.getCellRenderer(name);
    };

    handleMenuClick(identifier) {
        super.handleMenuClick(identifier);
    }

    renderExtension() {
    };

    onCancelHandler = () => {
        this.setState({renderTarget: null});
    };

    renderActionCell = (instance, params, columnId, _) => {
        if (params.row.id > this.state.buffer.length - 1) return;

        return (
            <div style={{width: "50px", backgroundColor: "#FFFFFF", marginLeft: "-9px", paddingLeft: "8px", marginRight: "auto", marginTop: "auto", marginBottom: "auto", height: "100%"}}>
                <IconButton className={css_buttons.blueIconButton} onClick={(event) => {
                    if (this.state.tableActionMenuTarget === null) {
                        this.setState({tableActionMenuTarget: event.currentTarget});
                    } else {
                        this.setState({tableActionMenuTarget: null});
                    }
                }}>
                    <MoreVert />
                </IconButton>
                <Menu anchorEl={this.state.tableActionMenuTarget}
                      anchorOrigin={{vertical: "bottom", horizontal: "right"}}
                      transformOrigin={{vertical: -10, horizontal: "center"}}
                      open={this.state.tableActionMenuTarget !== null && this.state.tableActionMenuTarget !== undefined}
                      onClose={() => this.setState({tableActionMenuTarget: null})}
                      TransitionProps={{
                          onExited: () => this.setState({tableActionMenuTarget: null}),
                      }}
                      MenuListProps={{
                          ...{"data-cc-component": "NavMenu"},
                          disablePadding: true,
                          style: {"minWidth": "200px"},
                      }}
                      PaperProps={{
                          elevation: 2,
                      }}
                >
                </Menu>
            </div>
        );
    };
}

export default withNavigate(withAppContext(withBreakpoint(EmployeeTable)));